<div class="modal-header">
  <h5 class="modal-title">Perfil</h5>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="closeModal()"
  ></button>
</div>
<div class="modal-body">
  <div class="bloco-subtitulo">
    <p class="subtitulo">Ajuste aqui os dados do seu perfil</p>
  </div>

  <form
    action="/FerramentaUsuario/MeusDados/Atualizar_Dados_Usuario_Post.asp"
    method="POST"
    id="frmMeusDados"
    name="frmMeusDados"
  >
    <div class="row">
      <div class="col-md-6">
        <label for="nome">Nome</label>
        <input
          type="text"
          id="txtNome"
          name="txtNome"
          maxlength="50"
          size="40"
          value="<%=strNome%>"
          class="form-control"
        />
      </div>
      <div class="col-md-6">
        <label for="email">E-mail</label>
        <input
          type="text"
          id="txtEmail"
          name="txtEmail"
          maxlength="50"
          size="40"
          [(ngModel)]="txtEmail"
          class="form-control"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-6" hidden>
        <label for="profissao">Qual sua profissão?</label>
        <input
          type="text"
          id="profissao"
          class="form-control"
          name="profissao"
        />
      </div>
      <div class="col-md-6">
        <label for="celular">Celular com DDD</label>
        <input
          type="text"
          id="txtTelefone"
          name="txtTelefone"
          size="10"
          maxlength="8"
          value="<%=strTelefone%>"
          class="form-control"
        />
      </div>
      <div class="col-md-6">
        <
        <label for="senha">Sua senha</label>
        <input
          type="password"
          class="form-control"
          id="strSenha"
          name="strSenha"
          value="<%=strSenha%>"
        />
      </div>
    </div>

    <div class="row">
      <!-- <div class="col-md-6">
        <label for="senha">Sua senha</label>
        <input
          type="password"
          class="form-control"
          id="strSenha"
          name="strSenha"
          value="<%=strSenha%>"
        />
      </div> -->
      <div class="col-md-12">
        <button
          type="submit"
          class="btn btn-primary"
          (click)="openAlterarSenhaModal()"
        >
          alterar senha
        </button>
      </div>
    </div>
  </form>
  <div class="modal-footer"></div>
</div>
